<script setup>
import { computed, defineEmits, defineProps, ref } from "vue";
import { useStore } from "vuex";
import useModal from "@/composables/useModal";
import { notifyProductStock } from "@/api";

const props = defineProps({
  productId: {
    type: Number,
    required: true,
  },
  productName: {
    type: String,
  },
  productMainImageUrl: {
    type: String,
  },
  useOption: Boolean,
  productOptionGroups: { type: Array, default: () => [] },
  productOptionCombines: { type: Array, default: () => [] },
});

const emits = defineEmits(["close"]);

const store = useStore();
const userId = computed(() => store.getters.userId);
const telephone = computed(() => store.state.telephone || "");

const { alert } = useModal();

const combineKey = ref(null);

const soldOutProductOptionCombines = computed(() =>
  !props.useOption
    ? []
    : props.productOptionCombines
        .filter(
          (combine) =>
            combine.status === "out_of_stock" ||
            Number(combine.stock || 0) === 0
        )
        .map((combine) => ({
          ...combine,
          name: combine.options.map((option) => option.name).join(" / "),
        }))
);

async function setStockNotify() {
  const selectedCombine = soldOutProductOptionCombines.value.find(
    ({ key }) => key === combineKey.value
  );

  const res = await notifyProductStock({
    productId: props.productId,
    memberId: userId.value,
    optionDataKey: selectedCombine?.key, //string(옵션 키)
    optionDataName: selectedCombine?.name, //string(옵션 이름)
    optionData: selectedCombine ? JSON.stringify(selectedCombine) : null,
  });

  if (res.data.code === 200) {
    alert("신청이 완료되었습니다");
    close();
  } else {
    alert("오류입니다 관리자에게 문의 부탁드립니다");
  }
}

function close() {
  emits("close");
}
</script>

<template>
  <div class="popup-bg on"></div>
  <div class="popup-cont w01 type-notice on" id="popup-notice">
    <div class="popup-header">
      <h3 class="title">재입고 알림 신청</h3>
      <button type="button" class="popup-close-btn" @click="close">닫기</button>
    </div>
    <div class="popup-body">
      <div class="goods_area">
        <div class="goods_img">
          <div
            class="img"
            :style="`background-image: url(${productMainImageUrl})`"
          >
            관리자가 등록한 상품명
          </div>
        </div>
        <p>
          <strong>{{ productName }}</strong>
          <span> </span>
        </p>
      </div>
      <div class="popup_write">
        <div class="input_wrap">
          <form action="">
            <template
              v-if="useOption && soldOutProductOptionCombines.length > 0"
            >
              <p class="input_tit">옵션 선택</p>
              <div class="input_area">
                <select v-model="combineKey">
                  <option :value="null">옵션을 선택하세요</option>
                  <option
                    v-for="item in soldOutProductOptionCombines"
                    :key="`sold-out-option-${item.key}`"
                    :value="item.key"
                  >
                    {{ item.name }}
                  </option>
                </select>
              </div>
            </template>
            <p class="input_notice02">
              품절된 상품의 재입고시 알림톡으로 알려드립니다.
            </p>
            <div>
              <p class="input_tit">휴대폰 번호</p>
              <div class="input_area">
                <input type="text" maxlength="11" :value="telephone" readonly />
              </div>
            </div>
            <p class="input_notice">
              재입고 알림 요청 상품의 가격, 옵션 구성 등의 상품 정보가 변동 될
              수 있습니다.
            </p>
            <p class="input_notice">
              재입고 알림 요청은 요청일로부터 3개월간 유효합니다.
            </p>
            <div class="btn_area">
              <button type="button" class="btn form02" @click="setStockNotify">
                확인
              </button>
              <button type="button" class="btn" @click="close">취소</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
